<script>
/**
 * Functional logic of a custom height-auto transition, from:
 *
 * Transition to Height Auto With Vue.js
 * https://markus.oberlehner.net/blog/transition-to-height-auto-with-vue/
 * Posted on 3 June 2018, by Markus Oberlehne
 */
  export default {
    name: 'FabricTransitionHeight',
    props: {
      name: {
        type: String,
        default: 'fabric-transition',
      },
      duration: {
        type: Number,
        default: 1000,
        validator: function (value) {
          // The value must match one of these Numbers
          return [1000,700,500,300,200,150,100,75].includes(value)
        }
      },
      height: {
        type: [Number, String],
        default: 0,
      },
    },
    data() {
      return {
        durationClass: '',
        initialHeightClass: '',
      }
    },
    computed: {
      usedStyle() {
        return {
          duration: 'tw-duration-75 tw-duration-100 tw-duration-150 tw-duration-200 tw-duration-300 tw-duration-500 tw-duration-700 tw-duration-1000',
          height: 'tw-h-[0px] tw-h-[43px] tw-h-[78px] tw-h-[102px] tw-h-[131px] tw-h-[155px] tw-h-[179px] tw-h-[184px] tw-h-[208px] tw-h-[232px] tw-h-[237px] tw-h-[256px] tw-h-[261px] tw-h-[285px] tw-h-[290px] tw-h-[309px] tw-h-[314px] tw-h-[319px] tw-h-[333px] tw-h-[343px] tw-h-[338px] tw-h-[362px] tw-h-[367px] tw-h-[386px] tw-h-[391px] tw-h-[410px] tw-h-[415px]',
        }
      }
    },
    created(){
      this.durationClass = `tw-duration-${this.duration}`
      this.initialHeightClass = `tw-h-${this.height}p`
    },
    methods: {
      enter(element) {
        const width = getComputedStyle(element).width;

        element.style.width = width;
        element.style.position = 'absolute';
        element.style.visibility = 'hidden';
        element.style.height = 'auto';

        const height = getComputedStyle(element).height;

        element.style.width = null;
        element.style.position = null;
        element.style.visibility = null;
        element.style.height = `${this.height}px`;

        // Force repaint to make sure the
        // animation is triggered correctly.
        // eslint-disable-next-line no-unused-expressions
        getComputedStyle(element).height;

        // Trigger the animation.
        // We use `requestAnimationFrame` because we need
        // to make sure the browser has finished
        // painting after setting the `height`
        // to `0` in the line above.
        requestAnimationFrame(() => {
          element.style.height = height;
        });
      },
      afterEnter(element) {
        element.style.height = 'auto';
      },
      leave(element) {
        const height = getComputedStyle(element).height;

        element.style.height = height;

        // Force repaint to make sure the
        // animation is triggered correctly.
        // eslint-disable-next-line no-unused-expressions
        getComputedStyle(element).height;

        requestAnimationFrame(() => {
          element.style.height = `${this.height}px`;
        });
      },
    },
  };
</script>

<template>
  <article>
    <transition
      :name="name"
      :enter-class="initialHeightClass"
      :enter-active-class="'fabric-transition-enter-active ' + durationClass"
      :leave-to-class="initialHeightClass"
      :leave-active-class="'fabric-transition-leave-active ' + durationClass"
      css
      @enter="enter"
      @after-enter="afterEnter"
      @leave="leave">
      <slot/>
    </transition>
  </article>
</template>

<style scoped>
/* Unable to use this for GFX acceleration as this breaks modals
 * due to the way `position: absolute` finds its binding box
* {
  will-change: height;
  transform: translateZ(0);
  backface-visibility: hidden;
  perspective: 1000px;
} */

.fabric-transition-enter-active,
.fabric-transition-leave-active {
  /* transition-duration: 1s; */
  transition-property: height;
  transition-timing-function: ease-in-out;
  overflow: hidden;
}

/* .fabric-transition-enter,
.fabric-transition-leave-to {
  height: 0;
} */
</style>
